import { LOG_API_CALL_DURATION_ENABLE } from '@aibees/elephant/constants';
import { UseBoolean } from '@aibees/shared/hooks';
import {
  encodeQueryParamValues,
  peformanceLogTime,
} from '@aibees/shared/utils';
import { useCallback } from 'react';
import { SearchFilter } from '../../../types';

export function useOnChangeSelection(
  field: string,
  metadata: SearchFilter['metadata'],
  changeParam: (value?: string) => void,
  setSearchInputValue: (value: string) => void,
  open: UseBoolean
) {
  return useCallback(
    (selectedItems: string[], selectedValue?: string) => {
      if (LOG_API_CALL_DURATION_ENABLE)
        peformanceLogTime(`filter change start: ${field}`);

      if (metadata?.autocomplete?.multiple) {
        const stringValue = encodeQueryParamValues(selectedItems);
        changeParam(stringValue);
      } else {
        setSearchInputValue('');
        changeParam(selectedValue);
        open.onFalse();
      }

      if (LOG_API_CALL_DURATION_ENABLE)
        peformanceLogTime(`filter change end: ${field}`);
    },
    [field, metadata, changeParam, setSearchInputValue, open.onFalse]
  );
}
